<div class="content-pagination">
    <mat-form-field class="items-to-show" [ngClass]="{'items-to-show-all': totalRecords}">
        <mat-select [formControl]="numItems" matTooltip="Items a mostrar" (selectionChange)="asingNumberItems($event)">
            <mat-option *ngFor="let number of limitOptions" [value]="number">
            {{ number }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <button
    matSuffix
    mat-icon-button
    aria-label="preview"
    (click)="initPage()"
    [disabled]="this.pagination.offset<=0"
    >
    <mat-icon
    matTooltip="inicio"
    class="icon-left"
    >first_page</mat-icon>
    </button>
    <button
    matSuffix
    mat-icon-button
    aria-label="preview"
    (click)="previousPage()"
    [disabled]="this.pagination.offset<=0"
    >
    <mat-icon
    matTooltip="anterior"
    class="icon-left"
    >chevron_left</mat-icon>
    </button>
    <div *ngIf="totalRecords" class="mat-pages-label">{{ getPagesLabel(offset,limit) }}</div>
    <button
    *ngIf="!totalRecords"
    matSuffix
    mat-icon-button
    aria-label="next"
    (click)="nextPage()"
    [disabled]="stopNextPaginator"
    >
    <mat-icon
    matTooltip="siguiente"
    class="icon-right"
    >chevron_right</mat-icon>
    </button>
    <button
    *ngIf="totalRecords"
    matSuffix
    mat-icon-button
    aria-label="next"
    (click)="nextPage()"
    [disabled]="isLastPage()"
    >
    <mat-icon
    matTooltip="siguiente"
    class="icon-right"
    >chevron_right</mat-icon>
    </button>
    <button
    *ngIf="totalRecords"
    matSuffix
    mat-icon-button
    aria-label="next"
    (click)="lastPage()"
    [disabled]="isLastPage()"
    >
    <mat-icon
    matTooltip="fin"
    class="icon-right"
    >last_page</mat-icon>
    </button>
    <div *ngIf="totalRecords" class="mat-paginator-range-label">{{ getRangeLabel(offset,limit) }}</div>
</div>
